export const prefix = 'md';



// WEBPACK FOOTER //
// ./src/lib/utils/prefixer/index.js